<template>
  <div class="flex flex-col align-center h-full px-10">
    <h1 class="sm:text-3xl lg:text-4xl font-bold title-font text-default mb-4">Mes invitations</h1>
    <InvitationList :show-all="true" />
  </div>

</template>

<script>
import InvitationList from "../components/Invitation/InvitationList.vue";

export default {
  components: {
    InvitationList,
  },
}
</script>
